/* @flow */
import type { Action, AsyncAction, MediaSearchFullParams, MediaSearchParams } from '../../types';

import liferay from '../../services/api';

const onFailure = (error: Object) => console.warn(error);

const setFeaturedMediaSearch = (params: MediaSearchParams): Action => {
  return {
    type: 'SET_FEATURED_MEDIA_SEARCH',
    payload: params,
  };
};

const performFeaturedMediaSearch = (params: MediaSearchFullParams): AsyncAction => {
  //$FlowFixMe
  return {
    type: 'PERFORM_FEATURED_MEDIA_SEARCH_REQUEST',
    payload: params,
    promise: liferay.medias.find(params),
    meta: { onFailure },
  };
};

const fetchFeaturedMediaSearchPage = (params: MediaSearchFullParams): AsyncAction => {
  //$FlowFixMe
  return {
    type: 'FETCH_FEATURED_MEDIA_SEARCH_PAGE_REQUEST',
    payload: params,
    promise: liferay.medias.find(params),
    meta: { onFailure },
  };
};

const fetchFeatured = (id: number): AsyncAction => {
  //$FlowFixMe
  return {
    type: 'FETCH_FEATURED_REQUEST',
    payload: id,
    promise: liferay.featured.get(id),
    meta: { onFailure },
  };
};

const featuredMediaSetPageScroll = (pageScroll: number): Action => {
  return {
    type: 'FEATURED_MEDIA_SCROLL_PAGE',
    payload: pageScroll,
  };
};

const featuredMediaToggleExpandCategory = (categoryId: number): Action => {
  return {
    type: 'FEATURED_MEDIA_TOGGLE_EXPAND_CATEGORY',
    payload: categoryId,
  };
};

const featuredMediaSetCategorySlide = (categoryId: number, slideIndex: number): Action => {
  return {
    type: 'FEATURED_MEDIA_SET_CATEGORY_SLIDE',
    payload: {
      categoryId,
      slideIndex,
    },
  };
};

export default {
  fetchFeatured,
  setFeaturedMediaSearch,
  performFeaturedMediaSearch,
  fetchFeaturedMediaSearchPage,
  featuredMediaSetPageScroll,
  featuredMediaToggleExpandCategory,
  featuredMediaSetCategorySlide,
};
